<template>
  <transition name="fade">
    <base-button
      v-if="selectedContents.length"
      type="primary"
      size="sm"
      @click.native="$emit('delete')"
      >{{ $t('knowledge.search.delete-definitively') }}
      {{ selectedContents.length }}
      {{ $t('knowledge.search.lower-contents') }}
    </base-button>
  </transition>
</template>

<script>
export default {
  name: 'archive-bulk-action-row',
  props: {
    selectedContents: Array,
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.dropdown-item-danger {
  color: $red-mayday;
  background-color: rgba($yellow-mayday, 0.1);
}
</style>
